import React, { Suspense } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import Loader from "../../../Components/UI-KIT/Loader";
import { NotFoundPage } from "../../../Pages/NotFound.page";
import { NotSupportedPage } from "../../../Pages/NotSupported.page";
import OtherRoutesPaths from "./other.routesPaths";
import EmptyLayout from "../../../Layouts/Empty.layout";
import Error from "../../../Components/UI-KIT/Error";
import { routeBuilder } from "../../services/routeBuilder.service";
import noAuthRoutesPaths from "../noAuth.route/noAuth.routesPaths";
import { InternalServerErrorPage } from "../../../Pages/InternalServerError.page";
import { UIPage } from "../../../Pages/UI.page";

const otherRoutes: RouteObject[] = [
	{
		element: <EmptyLayout />,
		children: [
			{
				path: OtherRoutesPaths.NOT_FOUND,
				element: (
					<Suspense fallback={<Loader />}>
						<NotFoundPage />
					</Suspense>
				),
				errorElement: <Error />,
			},

			{
				path: OtherRoutesPaths.UI,
				element: (
					<Suspense fallback={<Loader />}>
						<UIPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: OtherRoutesPaths.NOT_SUPPORTED,
				element: (
					<Suspense fallback={<Loader />}>
						<NotSupportedPage />
					</Suspense>
				),
				errorElement: <Error />,
			},
			{
				path: OtherRoutesPaths.INTERNAL_SERVER_ERROR,
				element: <InternalServerErrorPage />,
				errorElement: <Error />,
			},
		],
	},
	{
		path: "",
		element: <Navigate to={routeBuilder([noAuthRoutesPaths.AUTHORIZATION])} />,
		errorElement: <Error />,
	},
];

export default otherRoutes;
